import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import i18n from '@/i18n'
import '@/sass/overrides.sass'

Vue.use(Vuetify)

export default new Vuetify({
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
  theme: {
    dark: localStorage.getItem('elevment_dark_mode') !== 'false',
    themes: {
      light: {
        primary: '#FF771C',        // Brand Primary Orange
        secondary: '#F6AB2E',      // Brand Secondary 1 (Yellow-Orange)
        accent: '#E7531A',         // Brand Secondary 2 (Red-Orange)
        success: '#34C759',        // macOS Green
        info: '#007AFF',           // macOS Blue
        warning: '#F6AB2E',        // Brand Secondary 1
        error: '#FF3B30',          // macOS Red
        background: '#F5F5F7',     // Soft Grey Background
        surface: '#FFFFFF',        // White Cards
        anchor: '#FF771C',         // Brand Primary
        sidebar: '#FFFFFF',        // White Sidebar
        card: '#FFFFFF',           // White Cards
        text: '#1D1D1F',           // Primary Text
        textSecondary: '#86868B',  // Secondary Text
        border: '#E5E5E7',         // Border Color
      },
      dark: {
        primary: '#FF771C',        // Brand Primary Orange (Neon in dark)
        secondary: '#F6AB2E',      // Brand Secondary 1 (Glow effect)
        accent: '#E7531A',         // Brand Secondary 2
        success: '#34C759',        // macOS Green (darker)
        info: '#007AFF',           // macOS Blue (darker)
        warning: '#F6AB2E',        // Brand Secondary 1
        error: '#FF3B30',          // macOS Red (darker)
        background: '#121212',     // True Black
        surface: '#1C1C1E',        // Dark Grey Surface
        anchor: '#FF771C',         // Brand Primary with glow
        sidebar: '#1C1C1E',        // Dark Sidebar
        card: '#1C1C1E',           // Dark Cards
        text: '#FFFFFF',           // White Text
        textSecondary: '#AEAEB2', // Light Grey Text
        border: '#38383A',         // Dark Border
      },
    },
    options: {
      customProperties: true
    }
  },
  icons: {
    iconfont: 'mdi',
  },
})
